import React from 'react';

import { Box, UnstyledButton } from '@any-ui-react/core';
import classNames from 'classnames';

import {
  ImageLoadable,
  PreviewSlider,
  PreviewSliderHandle,
  UploadedImageFile,
} from '@anyx/feature-crm/shared';


import { isManualActionURL, UrlAction } from '../line-message-form';

export interface LineImageTypeBubbleProps {
  id: string;
  cards?: {
    image?: UploadedImageFile;
    actionUrl?: UrlAction;
    actionLabel?: string;
  }[];
  className?: string;
  classes?: {
    slider?: string;
    slides?: string;
  };
}

const ImageTypeActionButton = ({ label, disabled }: { label?: string; disabled?: boolean }) => {
  return (
    <div className="absolute bottom-6 flex w-full items-center justify-center">
      <UnstyledButton
        className={`w-fit max-w-[200px] truncate rounded-full px-6 py-2 text-base font-semibold ${classNames(
          {
            'bg-gray-2 text-gray-5': disabled,
            'bg-black/[0.4] text-white opacity-90 shadow-md': !disabled,
          }
        )}`}
      >
        {label}
      </UnstyledButton>
    </div>
  );
};

export const LineImageTypeBubble = React.forwardRef<PreviewSliderHandle, LineImageTypeBubbleProps>(
  ({ id, cards = [], className, classes }, ref) => {
    return (
      <PreviewSlider ref={ref} id={id} className={className} classes={classes}>
        {cards.map(({ image, actionLabel, actionUrl }, i) => {
          return (
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            <Box<any>
              key={i}
              className="relative aspect-square h-full w-full overflow-hidden rounded-2xl"
              {...(isManualActionURL(actionUrl)
                ? {
                    component: 'a',
                    href: actionUrl.manual,
                    target: '_blank',
                    rel: 'noreferrer',
                  }
                : {})}
            >
              <ImageLoadable className="aspect-square" src={image?.src} alt={image?.name} />
              {actionLabel && (
                <ImageTypeActionButton label={actionLabel} disabled={image === undefined} />
              )}
            </Box>
          );
        })}
      </PreviewSlider>
    );
  }
);
